/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Security_Passkey_Create_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not add the passkey." |
*
* @param {Partner_Security_Passkey_Create_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_security_passkey_create_error = /** @type {((inputs?: Partner_Security_Passkey_Create_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Security_Passkey_Create_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Passkey konnte nicht hinzugefügt werden.")
	return /** @type {LocalizedString} */ ("Could not add the passkey.")
});